import axios from 'axios';
import { Cart } from '../models';

// "Add my free magnets" (issue #5218 item 8): POST the chosen pose to
// /api/v1/carts/:id/free_magnets. The server attaches the offer's $0 "Free Photo
// Magnets (offer)" sheet through Cart#sync_free_magnets! -- the ONE attach/detach
// implementation -- and answers { applied: false, reason } rather than 4xx when
// the tier is no longer live on the cart, so a stale page continues cleanly.
//
// Relies on the app's global axios.defaults.baseURL ('/api/v1') exactly like
// addBuyAllToCart; do NOT override baseURL (that 404s the route).
// The FRESH free-magnets flags for the cart after a package was just created.
// ONE mechanism for every entry point: the order-package-creating POST
// (/buy_all) answers with `qualifies_for_free_magnets` + `has_free_magnets`
// computed after the package exists; a path with no such response (the
// Graphiti OrderPackage save) re-reads the cart. Never the React Query cache
// or CustomerContext -- both predate the package and answered a stale `false`,
// which hid the magnet page for a family's first package.
export async function freeMagnetsStatus({ data, cartId }) {
  if (data && typeof data.qualifies_for_free_magnets === 'boolean') {
    return { qualifies: data.qualifies_for_free_magnets, hasFreeMagnets: !!data.has_free_magnets };
  }
  const res = await Cart.find(cartId);
  const cart = res?.data;
  return { qualifies: cart?.qualifiesForFreeMagnets === true, hasFreeMagnets: !!cart?.hasFreeMagnets };
}

export default function addFreeMagnets({ cartId, poseId, backgroundId }) {
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
  return axios.post(
    `/carts/${cartId}/free_magnets`,
    { pose_id: poseId, background_id: backgroundId },
    { headers: { 'X-CSRF-Token': csrfToken } },
  ).then((res) => res.data);
}

// The value quoted on the magnet page when the pricelist has no priced Magnets
// option to read it from (EL Fall 2027 has none yet -- see the PR). JH-HS Fall
// 2027 sells the pair at this price.
export const FREE_MAGNETS_FALLBACK_VALUE = 14.95;

// Is every pose in this session a baked-in-background JPG? Those are not sold
// on magnets, so the magnet page is not offered for them (the same reason the
// Buy All card hides).
//
// ONE implementation, asked by every caller that feeds the magnet gate --
// elementary's builder and the senior builder computed the identical reduce
// separately, which is the drift this codebase keeps paying for. Empty poses
// reduce to `true` (nothing to put on a magnet), matching the behaviour the
// elementary gate has always had.
export const isAllJpgPoses = (poses) => (poses || [])
  .reduce((acc, pose) => acc && !(pose?.extension || '').toLowerCase().includes('png'), true);
